import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { BaseModalComponent } from '../../../@commons/ui-components/modal/base-modal-component';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CloseBtnComponent } from '../../../@commons/@components/close-btn/close-btn.component';
import { Cultivation } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@entities/app/cultivation.entity';
import { CultivationItemViewerComponent } from '../../@components/hierarchy-item/cultivation-item-viewer/cultivation-item-viewer.component';
import { CalendarCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-list.response';

@Component({
  selector: 'vw-hierarchy-items-choice-modal',
  imports: [
    SharedModule,
    TranslateModule,
    NgClass,
    CloseBtnComponent,
    CultivationItemViewerComponent,
  ],
  templateUrl: './hierarchy-items-choice-modal.component.html',
  styleUrl: './hierarchy-items-choice-modal.component.scss'
})
export class HierarchyItemsChoiceModalComponent
  extends BaseModalComponent
  implements OnChanges {
  @Input() hierarchy: any;
  @Output() onCultivationSelected = new EventEmitter<
    Cultivation | CalendarCultivationListResponse
  >(); // Emit event when cultivation is selected
  imageUrl: string = '';
  constructor() {
    super();
  }

  onSelectCultivation(cultivation: Cultivation) {
    this.onCultivationSelected.emit(cultivation); // Emit event when cultivation is selected
  }

  ngOnChanges() {
    //TODO - Implement this method
    if (this.hierarchy && (this.hierarchy as any).files?.length > 0) {
      this.imageUrl = (this.hierarchy as any).files[
        (this.hierarchy as any).files.length - 1
      ].cdnUrl;
    }
  }
}
